import { Button } from 'reactstrap';

function ReportFilterToggleBar({ onShow, className = '' }) {
    return (
        <div className={`report-filter-toggle-bar ${className}`.trim()}>
            <Button
                color="primary"
                outline
                size="sm"
                type="button"
                className="report-filter-toggle-btn"
                onClick={onShow}
            >
                <i className="fa fa-filter" aria-hidden="true" />
                {' '}
                Show Filters
            </Button>
        </div>
    );
}

export default ReportFilterToggleBar;
